import React from "react";

// 🔧 Formatter modular untuk angka Pi
const formatPi = (value) => {
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 7,
    maximumFractionDigits: 7,
  });
};

export default function TransactionCard({ transaction, onClick }) {
  return (
    <div
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer"
      onClick={onClick}
    >
      <div className="p-4">
        {/* Header */}
        <div className="space-y-1">
          <p className="text-gray-500 text-sm">Transaction ID</p>
          <p className="font-mono font-medium">{transaction.identifier}</p>
        </div>

        {/* Detail */}
        <div className="flex justify-between items-end mt-4">
          <div>
            <p className="text-gray-500 text-sm">Date</p>
            <p className="font-medium">
              {new Date(transaction.created_at).toLocaleDateString("id-ID")}
            </p>
            <span
              className={`mt-2 inline-block px-3 py-1 rounded-full text-sm font-medium ${
                transaction.status === "complete"
                  ? "bg-green-100 text-green-800"
                  : "bg-yellow-100 text-yellow-800"
              }`}
            >
              {transaction.status}
            </span>
          </div>

          <div className="text-right">
            <p className="text-gray-500 text-sm">Amount</p>
            <p
              className="font-bold text-gray-700 text-lg"
              title={`Nilai asli: ${transaction.amount}`}
            >
              {formatPi(transaction.amount)} &#960;
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
